import { render, staticRenderFns } from "./cancelOrder.vue?vue&type=template&id=7661a167&"
import script from "./cancelOrder.vue?vue&type=script&lang=js&"
export * from "./cancelOrder.vue?vue&type=script&lang=js&"
import style0 from "./cancelOrder.vue?vue&type=style&index=0&id=7661a167&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports